// extracted by mini-css-extract-plugin
export var shake = "_m-0";